import Css from './Css.js';
import prevPlayImg from '../Images/control_preview_play.png';
import prevPauseImg from '../Images/control_preview_pause.png';
import conTipImg from '../Images/control_tip.png';
import remoteLogo from '../Images/status_remote_logo.png';
import backImg from '../Images/back.png';
import orderUtil from '../Utils/orderUtil.js';
import { useTranslation } from 'react-i18next';

//顶部菜单区域组件
function TopMenu(props){
  const { t } = useTranslation();
  const {points,connectToyStatus,middleWidth,editorMode,editorWidth,pf} = props.data;
  const {connectToyEvent,goPreview,goEdit,showSubmitDia,exitEdit,closeEditor} = props.method;
  let rightNavsWidth = 184;
  if(pf === "t9" || pf === "t10"){
    rightNavsWidth = 194;
  }
  const connectToyWidth = 230;
  let titleWidth = middleWidth - 40;
  let preBtnWidth = orderUtil.controlBoxWidth;
  let tmpW = editorWidth - connectToyWidth - preBtnWidth;
  if(tmpW < titleWidth){
    titleWidth = tmpW - 4;
  }
  let peWidth = titleWidth - rightNavsWidth;
  let txt = "Pattern Editor";
  if(editorMode.edMode === 2){
    txt = "Edit Pattern";
  }
  let connectTxt = "Connect to Remote";
  if(connectToyStatus && connectToyStatus.ctStatus === 2){
    connectTxt = "Connecting...";
  }else if(connectToyStatus && connectToyStatus.ctStatus === 3){
    connectTxt = "Connected to Remote";
  }else if(connectToyStatus && connectToyStatus.ctStatus === 4){
    connectTxt = "Connection failed";
  }

  return (
    <>
      <div style={ Css.topMenu }>
        {
          editorMode.edMode === 2 ?
          <div style={ Css.backArea }>
            <div style={ Css.backBtn } onClick={ exitEdit }>
              <img style={ Css.backImg } src={backImg} alt=""/>
              <div style={ Css.backTxt }>{t("back")}</div>
            </div>
          </div> : 
          <div style={ Css.ctrArea }>
            {
              connectToyStatus.ctStatus === 1 ?
              <div style={ Css.ctrBtn } onClick={ connectToyEvent }>{ t(connectTxt) }</div> : ""
            }
            {
              (connectToyStatus.ctStatus === 2 || connectToyStatus.ctStatus === 3 || connectToyStatus.ctStatus === 4) ?
              <div style={ Css.ctrTip }>
                <img src={remoteLogo} alt="" style={ Css.remoteLogo }/>
                <div style={ Css.conStatusTip }>{ t(connectTxt) }</div>
              </div> : ""
            }
          </div>
        }
        
        <div style={ Css.titleArea(titleWidth) }>
          <div style={ Css.ptTitle(peWidth, editorMode, rightNavsWidth) }>{t(txt)}</div>
          { 
            editorMode.edMode !== 2 ? 
            <div style={ Css.rightNavs(rightNavsWidth) }>
              <span style={ Css.rightMbtn } onClick={ closeEditor }>{t("Exit")}</span>
              {
                points.length > 0 ?
              <span style={ Css.rightMbtn } onClick={ showSubmitDia }>{t("Submit")}</span> : ""
              }
              {
                (points.length > 0 && editorMode.edMode === 1) ?
              <span style={ Css.rightMbtn } onClick={ goEdit }>{t("Edit Mode")}</span> : ""
              }
            </div> : ""
          }
        </div>
        <div style={ Css.previewArea(preBtnWidth) }>
          <div style={ Css.previewArea(preBtnWidth).prevBtn } onClick={ ()=>{ goPreview(editorMode) } }>
            {
              editorMode.edMode === 3 ? <img src={ prevPauseImg } alt="" style={ Css.previewArea(preBtnWidth).prevBtnImg }></img> : <img src={ prevPlayImg } alt="" style={ Css.previewArea(preBtnWidth).prevBtnImg }></img>
            }
            <div style={ Css.previewArea(preBtnWidth).txt }>{t("Preview")}</div>
          </div>
          <img src={ conTipImg } alt="" style={ Css.previewArea(preBtnWidth).conTipImg }></img>
        </div>
      </div>
    </>
  )
}
export default TopMenu;